import {
  COLUMNS_CONFIG,
  DEFAULT_COLUMNS,
  FIELDS,
  SUBSCRIPTIONS,
} from 'frontend/client-communication-templates/client-communication-templates-table-helpers'
import { IDataModelTypeConfig } from 'frontend/dataModels/types/IDataModelTypeConfig'

export const ClientCommunicationTemplateDataModelTypeConfig: IDataModelTypeConfig = {
  fields: FIELDS,
  subscriptions: SUBSCRIPTIONS,
  defaultColumns: DEFAULT_COLUMNS,
  columnConfig: COLUMNS_CONFIG,
}
